import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FloatingWhatsApp from "@/components/feature/FloatingWhatsApp";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <FloatingWhatsApp />
    </main>
  );
}